var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.00005C13.9999 9.26711 13.5988 10.5016 12.854 11.5267C12.1092 12.5517 11.059 13.3147 9.85392 13.7062C8.64886 14.0977 7.3508 14.0976 6.14576 13.7061C4.94073 13.3145 3.89059 12.5515 3.14584 11.5264C2.4011 10.5013 1.99999 9.26677 2 7.99971C2.00001 6.73265 2.40114 5.49812 3.14589 4.47305C3.89065 3.44798 4.9408 2.68499 6.14584 2.29343C7.35088 1.90188 8.64895 1.90186 9.854 2.29338",
    stroke: "#FF7A00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderOrange);
export default __webpack_public_path__ + "static/media/loader-orange.e7f790fed79d85c4522a182eb3d6e1b5.svg";
export { ForwardRef as ReactComponent };